import React from "react";

export default function CheckoutBuy() {
  return <>CheckoutBuy</>;
}
